function InfoComponent() {
    const steps = [
        {
            id: 1,
            title: "Add Image",
            paragraph: "Begin by selecting your preferred image. Whether it's a portrait or a product shot, ensure it's clear and high-resolution.",
            number: 1
        },
        {
            id: 2,
            title: "Select color shade",
            paragraph: "Choose a color shade that complements your image. This tool offers a variety of shades, each designed to give your photo a unique mood and feel.",
            number: 2
        },
        {
            id: 3,
            title: "Change background",
            paragraph: "When ready, click on the change button. Instantly see how your image transforms with the new background, giving it a refreshed and vibrant look.",
            number: 3
        },
        {
            id: 4,
            title: "Download image",
            paragraph: "Once your image is ready and you are completely satisfied with the outcome, it's time to make it yours. Click on the 'Download Image' button and download the enhanced photo directly to your device.",
            number: 4
        },
    ];

    return (
        <div className='w-full mx-auto'>
            <h2 className='text-center font-inter text-2xl font-bold text-slate-800 mt-6'>How does it work</h2>
            <h3 className="text-lg text-center text-gray-600 mb-4">How can you change the background of any image?</h3>
            <div className="flex flex-col md:flex-row">
                {steps.map(step => (
                    <div key={step.id} className="flex-1 bg-white p-6 rounded-lg shadow-lg m-2">
                        <div className="flex justify-center items-center bg-crayola-50 rounded-full w-16 h-16 mx-auto mb-4">
                            <span className="font-bold text-xl">{step.number}</span>
                        </div>
                        <h3 className="text-center font-bold text-lg mb-4 text-slate-800">{step.title}</h3>
                        <p className="text-center text-gray-600">
                            {step.paragraph}
                        </p>
                    </div>
                ))}
            </div>

        </div>
    );
}

export default InfoComponent;
